module.exports = __webpack_public_path__ + "static/media/5C.b8fab0f2.svg";